"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _UserMessage = _interopRequireDefault(require("./UserMessage"));

var _AgentMessage = _interopRequireDefault(require("./AgentMessage"));

var _TypingIndicator = _interopRequireDefault(require("./TypingIndicator"));

var ConversationThread = function ConversationThread(_ref) {
  var turns = _ref.turns,
      isLoading = _ref.isLoading,
      disabled = _ref.disabled,
      onButtonSelect = _ref.onButtonSelect,
      onFormSubmit = _ref.onFormSubmit,
      onFollowUpSelect = _ref.onFollowUpSelect,
      onSourceClick = _ref.onSourceClick;
  var lastAgentIndex = -1;

  for (var i = turns.length - 1; i >= 0; i--) {
    if (turns[i].role === 'agent') {
      lastAgentIndex = i;
      break;
    }
  } // Show the typing indicator only when we're waiting on the agent — i.e. the last
  // turn is the user's. After the agent replies, isLoading flips off and the indicator
  // disappears in place of the real agent bubble.


  var lastTurn = turns.length > 0 ? turns[turns.length - 1] : null;
  var showTypingIndicator = Boolean(isLoading) && (lastTurn === null || lastTurn.role === 'user');
  return (0, _preact.h)("div", {
    className: "forethought-agent__thread"
  }, turns.map(function (turn, index) {
    if (turn.role === 'user') {
      return (0, _preact.h)(_UserMessage.default, {
        key: turn.id,
        content: turn.content
      });
    }

    return (0, _preact.h)(_AgentMessage.default, {
      key: turn.id,
      turn: turn,
      isLastAgentTurn: index === lastAgentIndex,
      disabled: disabled,
      onButtonSelect: onButtonSelect,
      onFormSubmit: onFormSubmit,
      onFollowUpSelect: onFollowUpSelect,
      onSourceClick: onSourceClick
    });
  }), showTypingIndicator && (0, _preact.h)(_TypingIndicator.default, null));
};

var _default = ConversationThread;
exports.default = _default;